import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseClickable, SpacingRow, SpacingUnit } from 'components/ui';
import { FieldDefaultValueKind } from 'entities/common/fieldDefaultValue';
import { DictionarySettingsStore } from 'stores/models/fieldsSettings';

import { DataRenderer } from './DataRenderer';
import s from './DefaultValueRenderer.module.scss';
import { FormulaRenderer } from './FormulaRenderer';

type DefaultValueRendererProps = {
  store: DictionarySettingsStore;
};

/** Обертка для рендера значения по умолчанию (формула или отображение выбранного поля из радиобаттонов) */
const DefaultValueRenderer: React.FC<DefaultValueRendererProps> = ({
  store,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.defaultValueRenderer}>
      <div className={s.defaultValueRenderer__content}>
        <SpacingRow hSpacing={SpacingUnit.unit1}>
          <Typography.Text>
            {t('editForm.dictionaryDefaultValue')}
          </Typography.Text>
          <BaseClickable withHover withCursorPointer>
            <Tooltip title={t('editForm.dictionaryTooltip')} placement="top">
              <InfoCircleOutlined />
            </Tooltip>
          </BaseClickable>
        </SpacingRow>
        {store.dictionarySettingsDefaultValue.defaultValueDisplayMode ==
        FieldDefaultValueKind.formula ? (
          <FormulaRenderer store={store.dictionarySettingsDefaultValue} />
        ) : (
          <DataRenderer store={store.dictionarySettingsDefaultValue} />
        )}
      </div>
      <div className={s.defaultValueRenderer__wrapper}>
        {store.dictionarySettingsDefaultValue.clearIconParams.display && (
          <BaseClickable
            action={store.dictionarySettingsDefaultValue.clearIconParams.action}
            withHover
            withCursorPointer
          >
            <DeleteOutlined />
          </BaseClickable>
        )}
        {store.dictionarySettingsDefaultValue.editButtonParams.display && (
          <Button
            onClick={
              store.dictionarySettingsDefaultValue.editButtonParams.action
            }
          >
            {store.dictionarySettingsDefaultValue.editButtonParams.text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default observer(DefaultValueRenderer);
